import { IconSpinner } from '../IconSpinner'

import SpinnerOverlayIcon from '../../../../icons/spinner/spinner-overlay.svg'

function IconSpinnerOverlay({ Icon = SpinnerOverlayIcon, ...restProps }) {
  return <IconSpinner {...restProps} Icon={Icon} />
}

export default IconSpinnerOverlay
